export function WhyUs() {
  return (
    <section className="bg-gradient-to-b from-black via-[#0A0A0A] to-black py-28">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-20">
          <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-4">
            Authority Publishing
          </div>
          <h2 className="text-white text-5xl font-bold mb-5">
            Your Story Deserves More Than Self-Publishing
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] rounded-full mx-auto mb-6"></div>
          <p className="text-[#999999] text-lg max-w-3xl mx-auto leading-relaxed">
            Most books never reach their full potential because the author doesn't have the right publishing strategy.
          </p>
        </div>

        <div className="bg-gradient-to-br from-[#1C1C1C] to-[#0F0F0F] rounded-3xl border border-[#D4AF37]/10 p-12 mb-12">
          <p className="text-[#CCCCCC] text-lg leading-relaxed mb-6">
            At Daily Nest Publishing, we help you turn your book into an authority asset that builds your brand, attracts opportunities, and positions you as a leader in your industry.
          </p>
          <p className="text-[#CCCCCC] text-lg leading-relaxed">
            From manuscript to launch, our team handles the process so you can focus on sharing your message.
          </p>
        </div>
      </div>
    </section>
  );
}